/** @format */

import GridItem from '../../../../../components/Grid/GridItem';
import I18n from '../../../../../components/Translate/I18n';
import GridContainer from '../../../../../components/Grid/GridContainer';
import CheckBoxSimple from '../../../../../components/Form/CheckBoxSimple';
import CustomInputExtNumber from '../../../../../components/CustomInput/CustomInputExtNumber';
import CustomTextButtom from '../../../../../components/Buttons/CustomTextButton';
import React, { useEffect, useState } from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';

interface MultiInputPropsInterface {
    parameter: any;
    parameterKey: string;
    createValuesFromForm: (paramName: string, objectValue: object) => void | null;
    assignedValue?: any;
    isBME?: boolean;
    readOnly?: boolean;
}

export const SelectInput = (props: MultiInputPropsInterface): React.ReactElement => {
    const getValueOrArrayOfValues = (item: any): Array<string | number | boolean> => {
        if (item) {
            if (Array.isArray(item)) {
                return item.map((el: { value: any }) => el.value);
            } else {
                return [item];
            }
        }
        return [];
    };

    const { parameter, parameterKey, createValuesFromForm, assignedValue, isBME, readOnly } = props;

    const [isRequired, setIsRequired] = useState<boolean>(assignedValue ? assignedValue.required : props.parameter.required);
    const [defaultValue, setDefaultValue] = useState<string | number | boolean | null>(assignedValue ? assignedValue.default : null);
    const [allowedValue, setAllowedValue] = useState<Array<string | number | boolean>>(
        assignedValue ? getValueOrArrayOfValues(assignedValue.allowedValue) : []
    );

    const defaultValueCallback = (event: any): void => {
        const val = parameter.type === 'number' ? parseInt(event.target.value) : event.target.value;
        if (defaultValue === val) {
            setDefaultValue(null);

            let finalObject = {
                default: null,
                allowedValue: allowedValue.map((el) => {
                    return { value: el };
                }),
                required: isRequired,
            };

            createValuesFromForm(parameterKey, finalObject);
        } else {
            setDefaultValue(val);

            let newAll = allowedValue;
            if (!allowedValue.includes(val)) {
                newAll = [...allowedValue, val];
                setAllowedValue(newAll);
            }

            let finalObject = {
                default: val,
                allowedValue: newAll.map((el) => {
                    return { value: el };
                }),
                required: isRequired,
            };

            createValuesFromForm(parameterKey, finalObject);
        }
    };
    const availableValueCallback = (event: any): void => {
        const val = parameter.type === 'number' ? parseInt(event.target.value) : event.target.value;
        if (allowedValue.includes(val)) {
            const newAll = allowedValue.filter((el: any) => {
                return el !== val;
            });
            setAllowedValue(newAll);

            let finalObject = {
                default: defaultValue,
                allowedValue: newAll.map((el) => {
                    return { value: el };
                }),
                required: isRequired,
            };

            createValuesFromForm(parameterKey, finalObject);
        } else {
            const newAll = [...allowedValue, val];
            setAllowedValue(newAll);

            let finalObject = {
                default: defaultValue,
                allowedValue: newAll.map((el) => {
                    return { value: el };
                }),
                required: isRequired,
            };

            createValuesFromForm(parameterKey, finalObject);
        }
    };

    useEffect(() => {
        console.log(parameter, allowedValue, parameter.allowedValue);
    }, [parameter, allowedValue, parameter.allowedValue]);

    return (
        <GridContainer style={{ paddingBottom: 25 }}>
            <GridItem xs={4}>
                <I18n trans={'prov:feature.param_name'} valueObject={{ param_name: parameterKey }} />
            </GridItem>
            <GridItem xs={8}>
                <GridContainer>
                    <GridItem xs={12}>
                        <CheckBoxSimple
                            label={'prov:feature.required'}
                            checked={parameter.required}
                            disabled={readOnly ?? false}
                            callback={(): void => {
                                setIsRequired(!isRequired);
                                let finalObject = {
                                    default: defaultValue,
                                    allowedValue: allowedValue.map((el) => {
                                        return { value: el };
                                    }),
                                    required: !isRequired,
                                };

                                createValuesFromForm(parameterKey, finalObject);
                            }}
                        />
                    </GridItem>
                    <GridItem xs={6}>
                        <GridContainer>
                            <GridItem xs={12}>
                                <I18n trans={'prov:feature.default'} />
                            </GridItem>
                            <GridItem xs={12}>
                                {parameter.allowedValue &&
                                    Array.isArray(parameter.allowedValue) &&
                                    parameter.allowedValue.map((item: any) => {
                                        return (
                                            <GridItem xs={12} key={`default_radio_element_${item.value}`}>
                                                <FormControlLabel
                                                    value={item.value}
                                                    control={<Checkbox disabled={readOnly ?? false} checked={item.value === defaultValue} />}
                                                    label={item.value}
                                                    onChange={defaultValueCallback}
                                                />
                                            </GridItem>
                                        );
                                    })}
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                    <GridItem xs={6}>
                        <GridContainer>
                            <GridItem xs={12}>
                                <I18n trans={'prov:feature.allowed_value'} />
                            </GridItem>
                            <GridItem xs={12}>
                                {parameter.allowedValue &&
                                    Array.isArray(parameter.allowedValue) &&
                                    parameter.allowedValue.map((item: any) => {
                                        return (
                                            <GridItem xs={12} key={`default_radio_element_${item.value}`}>
                                                <FormControlLabel
                                                    value={item.value}
                                                    control={<Checkbox disabled={readOnly ?? false} checked={allowedValue.includes(item.value)} />}
                                                    label={item.value}
                                                    onChange={availableValueCallback}
                                                />
                                            </GridItem>
                                        );
                                    })}
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                </GridContainer>
            </GridItem>
        </GridContainer>
    );
};
